<template>
  <div>
    <article class="teachers-wrapper">
      <div class="container">
        <p class="title-text">Meet The Teachers</p>
      </div>
      <div class="slide-wrapper">
        <div class="container">
          <VueSlickCarousel v-bind="settings" v-if="slideList.length > 0">
            <div class="slide" v-for="(item, i) in slideList" :key="i">
              <div class="con">
                <div class="text-wrapper">
                  <p>{{ item.office }}</p>
                  <div class="line"></div>
                  <p>
                    이달의 우수강사 <span>{{ item.teacher_name }}</span>
                  </p>
                  <p>{{ item.headline }}</p>
                  <p class="more" @click="showImgView(item)">more</p>
                </div>
                <div class="img-wrapper">
                  <img :src="item.profileImg" alt="img" />
                </div>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </article>

    <!-- 이미지 뷰 모달 -->
    <ImageView
      v-if="isimgViewVisible"
      @closeImgView="hideImgView"
      :imgP="imageData.imgP"
      :imgM="imageData.imgM"
    ></ImageView>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import ImageView from "@/page/NewGlobal/ImageView.vue";

export default {
  components: { VueSlickCarousel, ImageView },
  data() {
    return {
      settings: {
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 9000,
        cssEase: "linear",
        pauseOnHover: true,
      },
      slideList: [],
      /* slideList_old: [
        {
          profileImg: require("@/assets/img/newGlobal/main/teachers/teacher01.png"),
          title: "Jinny Lee",
          sub: "지치지 않아야 합니다. 영어공부를 하기로 마음 먹었다면, 스스로와 약속한 시간까지는 근성을 가지고 밀어붙여야 합니다.",
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/teachers/Teachers_mobile_01.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/teachers/Teachers_pc_01.jpg",
        },
        {
          profileImg: require("@/assets/img/newGlobal/main/teachers/teacher02.png"),
          title: "피아오 리신",
          sub: "중요한 것은 '재미'입니다. 재미를 잃어버리면 지속적으로 공부하기가 힘들 수밖에 없어요.",
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/teachers/Teachers_mobile_02.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/teachers/Teachers_pc_02.jpg",
        },
        {
          profileImg: require("@/assets/img/newGlobal/main/teachers/teacher03.png"),
          title: "Jenny Chu",
          sub: "학습자가 스스로 발화해 보는게 너무나도 중요하기 때문에 반드시 수업 시간에 학습자분들이 충분히 발화하실 수 있도록 지도하고 있습니다.",
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/teachers/Teachers_mobile_03.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/teachers/Teachers_pc_03.jpg",
        },
      ], */

      isimgViewVisible: false,
    };
  },
  mounted() {
    this.getTeachers();
  },
  methods: {
    showImgView(item) {
      this.isimgViewVisible = true;
      this.imageData = {
        imgP: item.imgP,
        imgM: item.imgM,
      };
    },

    hideImgView() {
      this.isimgViewVisible = false;
    },
    
    getTeachers() {
      const params = {
        limit: 3,
      };
      axios
      .get("/rest/external/getTeachers", {params: params})
      .then((res) => {
        if (res.data.err == 0) {
          this.slideList = res.data.list;
        } else {
          console.error("res.data.err : ", res.data.err);
        }
      })
      .catch((err) => {
        alert("통신이 원활하지 않습니다.");
        console.error("err : ", err);
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.teachers-wrapper {
  position: relative;
  padding: 40px 0px;
  color: #232323;

  .title-text {
    font-size: 33px;
    font-weight: 700;
  }

  .slide-wrapper {
    padding-top: 20px;
    background-color: #f7f7f7;

    .con {
      img {
        width: 100%;
      }

      .text-wrapper {
        p:nth-of-type(1) {
          font-size: 24px;
          font-weight: 700;
          margin: 30px 0 20px;
        }

        .line {
          display: inline-block;
          width: 30px;
          height: 1px;
          background-color: #000000;
          margin-bottom: 10px;
        }

        p:nth-of-type(2) {
          font-size: 18px;
          margin-bottom: 20px;

          span {
            font-size: 30px;
            font-weight: 700;
          }
        }

        p:nth-of-type(3) {
          color: #888888;
          margin-bottom: 20px;
        }

        .more {
          display: inline-block;
          color: #232323;
          cursor: pointer;
        }
      }
    }

    .slick-slider::v-deep {
      .slick-slide {
        .slide {
          display: block !important;
        }
      }

      .slick-dots {
        text-align: left;
        bottom: 20px;
      }
    }
  }
}

@media screen and (min-width: 1350px) {
  .teachers-wrapper {
    padding: 80px 0px;

    .container {
      position: relative;
    }

    .title-text {
      font-size: 50px;
    }

    .slide-wrapper {
      .con {
        display: flex;
        gap: 100px;

        img {
          width: 454px;
        }

        .text-wrapper {
          p:nth-of-type(1) {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
